import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { appApiResources, appVariables, appMessages } from '../../core/constants/Common.constant';
import { ShoppingService } from '../../core/services/shopping.service';

@Component({
  selector: 'app-auto-log-out-dialog',
  templateUrl: './auto-log-out-dialog.component.html',
  styleUrls: ['./auto-log-out-dialog.component.css']
})
export class AutoLogOutDialogComponent implements OnInit {
  AutoLogOutMessage: any
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AutoLogOutDialogComponent>, private shoppingService: ShoppingService) { }

  ngOnInit() {
    this.AutoLogOutMessage = appMessages.AutoLogOutMessage;
  }
  OnContinueSessionClick(event) {
    this.shoppingService.SetTimerCall.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/auto-log-out-dialog/auto-log-out-dialog.component.ts